import React from 'react';
import {connect} from 'react-redux';

const mapStateToProps=state=>({
	display: state.projectInfo.urlParams.live
})
const LiveBanner=(props)=>{
	return(
		props.display?
			<div id="live-scanner-banner" className="jumbotron jumbotron-fluid hide_if_not_livescanner">
			  <div className="container">
			    <h1 className="display-4">Thank you for using Meterian</h1>
			    <h3 >You have successfully scanned a project.  This report provides an analysis of your project's security, stability and licence risks.</h3>
			    <br />
			    <br />
			    <h4 className="lead">Now you've seen it. Get to know your projects risks and do something about it.  Let Meterian secure your code projects' open source components so your software assets don't become an Achilles' heel in your organisation.  If you have any questions, see our FAQ (<a href="https://blog.meterian.com/faq/" target="_blank" rel="noopener noreferrer">https://blog.meterian.com/faq/</a>). </h4>
			  </div>
			</div>
		:null
	)
}
export default connect(mapStateToProps)(LiveBanner);